import { Injectable, computed, signal } from '@angular/core';
import { AppMode } from './app-mode';

@Injectable({ providedIn: 'root' })
export class ModeService {
  private readonly _mode = signal<AppMode>({ kind: 'unknown' });
  readonly mode = this._mode.asReadonly();
  readonly isPlatform = computed(() => this._mode().kind === 'platform');
  readonly isTenant = computed(() => this._mode().kind === 'tenant');
  readonly subdomain = computed(() => {
    const m = this._mode();
    return m.kind === 'tenant' ? m.subdomain : null;
  });

  setMode(mode: AppMode): void {
    this._mode.set(mode);
  }
}
